import { forwardRef } from "react";
import { Suspect } from "../types";
import StatsBlock from "./StatsBlock";
import ShareBlock from "./ShareBlock";

interface Props {
  suspects: Suspect[];
  selectedSuspect: string | null;
  bars: boolean;
  explanation: string;
  episodeTitle: string;
}

const RevealSection = forwardRef<HTMLDivElement, Props>(
  ({ suspects, selectedSuspect, bars, explanation, episodeTitle }, ref) => {
    const guilty = suspects.find((s) => s.guilty);
    const chosen = suspects.find((s) => s.id === selectedSuspect);
    const isCorrect = chosen?.guilty ?? false;
    const episodeUrl = window.location.href;

    return (
      <div className="reveal-section" ref={ref}>
        {/* Verdict */}
        <div className={`reveal-verdict ${isCorrect ? "correct" : ""}`}>
          <div className="verdict-label">— Your Verdict</div>
          <div className={`verdict-text ${isCorrect ? "right" : "wrong"}`}>
            {isCorrect
              ? `Correct. ${guilty?.name} is guilty.`
              : `Wrong. You accused ${chosen?.name}. The killer was ${guilty?.name}.`}
          </div>
        </div>

        {/* Explanation */}
        <p
          className="reveal-explanation"
          dangerouslySetInnerHTML={{ __html: explanation }}
        />

        {/* Stats */}
        <StatsBlock
          suspects={suspects}
          selectedSuspect={selectedSuspect}
          bars={bars}
          totalDetectives={14203}
        />

        {/* Share */}
        <ShareBlock
          isCorrect={isCorrect}
          guiltyName={guilty?.name ?? ""}
          episodeTitle={episodeTitle}
          episodeUrl={episodeUrl}
        />
      </div>
    );
  }
);

RevealSection.displayName = "RevealSection";

export default RevealSection;
